<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="工人类别">
              <a-input placeholder="请输入工人类别" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button
        @click="$refs.workerTypeAddOrUpdate.init('','add')"
        icon="plus"
        type="primary"
        v-action="'sys:common:workType:add'"
      >新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
    <workerType-add-or-update
      @ok="queryPage"
      ref="workerTypeAddOrUpdate"
    />
  </a-card>
</template>
<script>
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, delObj } from '@/api/common/WorkerType'
import workerTypeAddOrUpdate from './WorkerTypeAddOrUpdate'
import { enterEvent } from '@/utils/util'
export default {
  name: 'SxWorkerTypeView',
  mixins: [TableMixin],
  components: {
    workerTypeAddOrUpdate
  },
  data () {
    return {
      description: '创建管理工人类别，记录薪资水准',
      queryParam: {
        test: ''
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '100px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        // {
        //   title: '主键',
        //   dataIndex: 'id'
        // },
        {
          title: '工人类别',
          width: '180px',
          dataIndex: 'name'
        },
        // title: '工时价格，单位元（具体到两位小数）',
        {
          title: '工时价格',
          width: '180px',
          dataIndex: 'hourPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' - ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '操作',
          align: 'center',
          width: '230px',
          customRender: (record) => {
            return (
              <div>
                <span v-action="sys:common:workType:show">
                  <a onClick={(e) => this.show(record)}>查看</a>
                </span>
                <span v-action="sys:common:workType:edit">
                  <a-divider type="vertical" />
                  <a onClick={(e) => this.edit(record)}>修改</a>
                </span>
                <span v-action="sys:common:workType:del">
                  <a-divider type="vertical" />
                  <a-popconfirm title="是否删除" onConfirm={() => this.deleteItem(record)} okText="是" cancelText="否">
                    <a-icon slot="icon" type="question-circle-o" style="color: red" />
                    <a href="javascript:;" style="color: red">删除</a>
                  </a-popconfirm>
                </span>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    show (record) {
      this.$refs.workerTypeAddOrUpdate.init(record.id, 'show')
    },
    edit (record) {
      this.$refs.workerTypeAddOrUpdate.init(record.id, 'edit')
    },
    deleteItem (record) {
      delObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    }
  },
  created () {
    enterEvent(this.queryPage)
  }
}
</script>

<style scoped>

</style>
